import { Button, mergeClasses } from "@fluentui/react-components";
import { ChevronRightRegular } from "@fluentui/react-icons";
import { Row } from "@tanstack/react-table";
import { RowData } from "../../../models/weather/IWeatherForecast";

export interface IClassLabelsProps {
  row: Row<RowData>;
  isExpanded: boolean;
  className?: string;
  styles: {
    toggleBtn: string;
    chevron: string;
    chevronExpanded: string;
  };
}

export default function ClassLabel({
  row,
  isExpanded,
  className = "",
  styles,
}: IClassLabelsProps) {
  return (
    <div className={mergeClasses("amd-container-vcenter", className)}>
      <Button
        icon={
          <ChevronRightRegular
            fontSize="medium"
            className={mergeClasses(
              styles.chevron,
              isExpanded && styles.chevronExpanded
            )}
            aria-hidden
          />
        }
        onClick={row.getToggleExpandedHandler()}
        aria-label={isExpanded ? "Collapse" : "Expand"}
        aria-expanded={isExpanded}
        className={styles.toggleBtn}
      />
      <span style={{ fontWeight: 700, marginLeft: "4px" }}>
        {row.original.classLabel}
      </span>
    </div>
  );
}
